import PutawayConfiguration from '@/models/PutawayConfiguration/PutawayConfiguration';

export default class PutawayConfigurationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.putawayCategoryId  = '';
		this.putawayCategoryName = '';
		this.areaId  = '';
		this.areaCode = '';
		this.nextAreaId  = '';
		this.nextAreaCode = '';
		this.partClassificationId  = '';
		this.partClassificationCode = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			putawayCategoryId : '0',
			putawayCategoryName : '0',
			areaId : '0',
			areaCode : '0',
			nextAreaId : '0',
			nextAreaCode : '0',
			partClassificationId : '0',
			partClassificationCode : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}